import { SET_SEARCH } from "../actions/types";

const initialState = "";

const search = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH:
      return action.payload;
    default:
      return state;
  }
};

export default search;
